

























import Vue from "vue";
import Component, { mixins } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import NoOutputTable from "@/components/common/NoOutputTable.vue";
import { State, namespace } from "vuex-class";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import AxiosMixin from "../mixins/axiosMixin";

const StoreYearmonth = namespace("yearmonth");

@Component({
  components: {
    NoOutputTable
  }
})
export default class AllNoOutput extends mixins(AxiosMixin) {
  //年月
  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  //医療番号
  private medicalNo = 0;

  //介護番号
  private careNo = 1;

  //選択中のタブ
  private selectTabItem = 0;

  private headers = [
    {
      value: "yearmonth_disp",
      text: "サービス提供年月",
      width: "108px"
    },
    {
      value: "no_commit_count",
      text: "明細データ未確定",
      width: "108px"
    },
    {
      value: "no_exec_count",
      text: "未処理",
      width: "108px"
    },
    {
      value: "edit",
      text: "編集",
      width: "90px"
    }
  ];

  //医療
  private medicals = [];

  //介護
  private cares = [];

  //画面描画
  mounted() {
    this.updateData();
    const tab = this.$route.query.tab;
    if (typeof tab === "string") {
      this.selectTabItem = parseInt(tab);
    }
  }

  //選択中のタブ変更時
  @Watch("selectTabItem")
  handleSelectTabItem(before: number, after: number) {
    if (before !== after) {
      this.$router.replace({ path: "/all_no_output?tab=" + before });
    }
  }

  //データ取得
  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/all_no_output/get",
      {},
      res => {
        this.medicals = res.data.medicals;
        this.cares = res.data.cares;
      }
    );
  }

  //処理するボタンクリック
  private edit(yearmonth: string, no: number) {
    //年月変更
    this.yearmonth = yearmonth;
    switch (no) {
      case this.medicalNo:
        if (yearmonth <= "2024-03") {
          this.$router.push({ path: "/medical/merge" });
        }
        if (yearmonth >= "2024-04") {
          this.$router.push({ path: "/medical/transmission" });
        }
        break;
      case this.careNo:
        this.$router.push({ path: "/care/merge" });
        break;
    }
  }
}
